import { TextField } from "@mui/material";
import { useEffect, useState } from "react";

import { useDebounce } from "../../../../hooks/useDebounce";
import { useQueryParams } from "../../../../hooks/useQueryParams";

export default function SearchWithParams({ queryKey, label }) {
  const { filters, updateFilter } = useQueryParams();
  const [search, setSearch] = useState(filters.get(queryKey) || "");
  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    updateFilter(queryKey, debouncedSearch || undefined);
  }, [debouncedSearch]);

  return (
    <div className="mt-3">
      <TextField
        className="w-full rounded-lg text-sm placeholder:text-center"
        placeholder={label}
        size="small"
        name={queryKey}
        value={search}
        InputLabelProps={{ shrink: true }}
        label={label}
        onChange={(event) => setSearch(event.target.value)}
      />
    </div>
  );
}
